<div class="modal-header flex flex-row justify-between items-center">
  <h1>Delete Confirmation</h1>
  <mat-icon id="close-icon" (click)="closeDialog()">close</mat-icon>
</div>
<mat-dialog-content>
  <div class="m-b-5">This file has been shared with x People</div>
  <br>
  <div class="m-b-5">Are you sure you want to delete this file?</div>
</mat-dialog-content>
<mat-dialog-actions class="modal-footer flex flex-row justify-between items-center">
  <button mat-button class="orbitax-footer-button" id="no-button" [mat-dialog-close]="false">NO</button>
  <button mat-button class="orbitax-footer-action-button" id="yes-button" [mat-dialog-close]="true">YES</button>
</mat-dialog-actions>
